/* eslint-disable jsx-a11y/label-has-associated-control */
import classnames from 'classnames'
import PropTypes from 'prop-types'
// Components
import { CheckBox } from 'src/Components'
// Styles
import styles from './FilterCheckBox.module.scss'

const FilterCheckBox = ({ className, ...restProps }) => {
  const { checked } = { ...restProps }

  return (
    <div
      className={classnames(styles.root, checked && styles.checked, className)}
    >
      <label>
        <CheckBox className={styles.checkBox} {...restProps} />
      </label>
    </div>
  )
}
const propTypes = {
  className: PropTypes.string,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  disabled: PropTypes.bool,
}

FilterCheckBox.propTypes = propTypes


export default FilterCheckBox
